module.exports = __webpack_public_path__ + "static/media/KZ.4a725b02.png";